import React from 'react'
import { useSlate } from 'slate-react'
import { IconMaps } from '@ow/icons'
import BaseButton from './BaseButton'
import { isBlockActive, TEXT_ALIGN_TYPES, toggleBlock } from '../utils/util'

// 块级按钮 标题/列表/居中..
const BlockButton = ({ format, icon, tip, uploadImg }) => {
  const editor = useSlate()
  return (
    <BaseButton
      tip={tip}
      active={isBlockActive(
        editor,
        format,
        TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
      )}
      onMouseDown={(event) => {
        event.preventDefault()
        toggleBlock(editor, format, null, uploadImg)
      }}
    >
      <IconMaps
        type={icon}
        width={18}
        height={18}
        fill={
          // 暂时先用主题色，等梓芸将icon修改好之后再用二进制色值
          isBlockActive(
            editor,
            format,
            TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
          )
            ? 'dark'
            : 'gray'
          // isBlockActive(
          //   editor,
          //   format,
          //   TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
          // )
          //   ? '#000'
          //   : '#ccc'
        }
      />
    </BaseButton>
  )
}

export default BlockButton
